import React, { Component } from 'react';
import { setJSONLocalStorage, getJSONLocalStorage, getToken } from '../../functions/app_functions.js';
import withRouter from '../../with_router.js';
import ForminputText from '../forminput/forminput_text.js';
import ForminputTextbox from '../forminput/forminput_textbox.js';
import ForminputDate from '../forminput/forminput_date.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js';
import ForminputPassword from '../forminput/forminput_password.js';
import Tripcarousel from './tripcarousel.js';
import MissingPage from '../error/missingpage.js';
import { format_month_year } from '../../functions/functions_formatting.js';
import { ReactComponent as IconEdit } from '../../media/icons/edit.svg';
import { ReactComponent as IconLink } from '../../media/icons/arrow_right.svg';
import { ReactComponent as IconLocation } from '../../media/icons/location.svg';
import { ReactComponent as IconFacebook } from '../../media/icons/social_facebook.svg';
import { ReactComponent as IconYoutube } from '../../media/icons/social_youtube.svg';
import { ReactComponent as IconInstagram } from '../../media/icons/social_instagram.svg';
import { ReactComponent as IconTiktok } from '../../media/icons/social_tiktok.svg';
import { ReactComponent as IconSnapchat } from '../../media/icons/social_snapchat.svg';
import { ReactComponent as IconLinkedin } from '../../media/icons/social_linkedin.svg';
import { ReactComponent as IconTwitterx } from '../../media/icons/social_twitterx.svg';
import { ReactComponent as IconHome } from '../../media/icons/social_home.svg';
import { ReactComponent as IconAdd } from '../../media/icons/plus.svg';


class Account extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            user_id: null,
            login: null,
            page: "",
            uploading: false,
            upload_image_file: null,
            sample_picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/users/male.webp",
            data: {
                name: "",
                username: "",
                picture: {},
                bio_description: "",
                birthday: "",
                country: "",
                hometown: "",
                cities: [],
                facebook: "",
                youtube: "",
                instagram: "",
                tiktok: "",
                linkedin: "",
                twitterx: "",
                snapchat: "",
                website: ""
            },
            userTrips: [],
            userTripViews: [],
            userTripUnlocks: [],
            email: "",
            password_old: "",
            password_new: "",
            password_new_2: ""
        };

        this.baseUrl = this.props.baseUrl;

        this.loadUserData = this.loadUserData.bind(this);
        this.loadUserTripData = this.loadUserTripData.bind(this);
        this.loadUserTripViewData = this.loadUserTripViewData.bind(this);
        this.loadUserTripUnlockData = this.loadUserTripUnlockData.bind(this);
        this.setPage = this.setPage.bind(this);
        this.setDataValue = this.setDataValue.bind(this);
        this.setFormValue = this.setFormValue.bind(this);

        // Functions to validate and submit form updates
        this.verifyProfileData = this.verifyProfileData.bind(this);
        this.verifyEmailData = this.verifyEmailData.bind(this);
        this.verifyPasswordData = this.verifyPasswordData.bind(this);
        this.submitProfileData = this.submitProfileData.bind(this);
        this.submitEmailData = this.submitEmailData.bind(this);
        this.submitPasswordData = this.submitPasswordData.bind(this);
        this.handleFileChangePicture = this.handleFileChangePicture.bind(this);
        this.updatePicture = this.updatePicture.bind(this);
    }


    async componentDidMount() {
        await this.props.setLoading();
        var user_id = null;
        var username = null;
        var login = false;
        if (this.props.params.userid) {
            user_id = null;
            username = this.props.params.userid;
        }
        else if (this.props.login && this.props.user_id) {
            user_id = this.props.user_id
            login = true;
        } else {
            user_id = null;
            username = null;
        }
        user_id = parseInt(user_id);
        await this.setState({
            user_id: user_id,
            login: login
        });
        // Run API calls in parallel
        try {
            await Promise.all([
                this.loadUserData(user_id, username),
                this.loadUserTripData(user_id, username),
                this.props.login ? this.loadUserTripViewData(user_id, username) : Promise.resolve(),
                this.props.login ? this.loadUserTripUnlockData(user_id, username) : Promise.resolve()
            ]);
        } catch (error) {
        }
        await this.props.unsetLoading();
    }


    async loadUserData(user_id, username = null) {
        try {
            var userdata = [];
            if (user_id) {
                userdata = getJSONLocalStorage(user_id + "_userdata", 1);
            }
            if (username) {
                userdata = getJSONLocalStorage(username + "_userdata", 1);
            }
            if (userdata && userdata.user_id && userdata.user_id.length > 0) {
                this.setState({
                    data: userdata
                });
                this.props.unsetLoading();
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getuserdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id,
                    username: username
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.user_id) {
                // Set data to state
                if (data.birthday) {
                    const birthday = data.birthday;
                    const parts = birthday.split('/');
                    const formattedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
                    data.birthday = formattedDate;
                }
                this.setState({
                    data: data
                });
                setJSONLocalStorage(data.user_id + "_userdata", data);
                setJSONLocalStorage(data.username + "_userdata", data);
            } else {
                // Set data to state
                this.setState({
                    missingdata: true
                });
                // Track error
                var name = "";
                var message = "Could not load user data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Set data to state
            this.setState({
                missingdata: true
            });
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_loadUserData");
        }
    }


    async loadUserTripData(user_id, username = null) {
        try {
            var usertripdata = getJSONLocalStorage(user_id + "_usertripdata", 1);
            if (usertripdata && usertripdata.length > 0) {
                this.setState({
                    userTrips: usertripdata
                });
                this.props.unsetLoading();
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getusertrips", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id,
                    username: username
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                // Sort by updated
                const sortedData = data.sort((a, b) => {
                    const lastUpdatedA = (a.updated && a.updated.length > 0) ? new Date(a.updated[a.updated.length - 1]) : new Date(0);
                    const lastUpdatedB = (b.updated && b.updated.length > 0) ? new Date(b.updated[b.updated.length - 1]) : new Date(0);
                    return lastUpdatedB - lastUpdatedA; // Sort descending
                });
                this.setState({
                    userTrips: sortedData
                });
                setJSONLocalStorage(user_id + "_usertripdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load user data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_loadUserTripData");
        }
    }


    async loadUserTripViewData(user_id) {
        try {
            var usertripviewdata = getJSONLocalStorage(user_id + "_usertripviewdata", 1);
            if (usertripviewdata && usertripviewdata.length > 0) {
                this.setState({
                    userTripViews: usertripviewdata
                });
                this.props.unsetLoading();
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getusertripviews", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    userTripViews: data
                });
                setJSONLocalStorage(user_id + "_usertripviewdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load user data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_loadUserTripViewData");
        }
    }


    async loadUserTripUnlockData(user_id) {
        try {
            var usertripunlockdata = getJSONLocalStorage(user_id + "_usertripunlockdata", 1);
            if (usertripunlockdata && usertripunlockdata.length > 0) {
                this.setState({
                    userTripUnlocks: usertripunlockdata
                });
                this.props.unsetLoading();
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getusertripunlocks", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    userTripUnlocks: data
                });
                setJSONLocalStorage(user_id + "_usertripunlockdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load user data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_loadUserTripUnlockData");
        }
    }


    setPage(page) {
        this.setState({ page: page });
    }


    setDataValue(label, value) {
        var data = this.state.data;
        data[label] = value;
        this.setState({ data: data });
    }


    setFormValue(label, value) {
        this.setState({ [label]: value });
    }


    handleFileChangePicture(event) {
        this.setState({
            upload_image_file: event.target.files[0]
        });
    }


    async updatePicture() {
        this.props.setLoading();
        this.setState({ uploading: true });
        const file = this.state.upload_image_file;
        if (!file) {
            alert('Please select an image file');
            return;
        }

        try {
            // Step 1: Request a pre-signed URL for each file
            const payload = {
                file_name: file.name,
                file_type: file.type
            };
            const response = await fetch(this.props.baseUrl + "/createuploadurl", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify(payload)
            });
            // Handle response
            if (!response.ok) throw new Error(`Failed to get pre-signed URL for ${file.name}`);
            const jsonResponse = await response.json();
            const url = jsonResponse.value.link.url;
            const key = jsonResponse.value.link.key;
            if (!url || !key) {
                throw new Error(`Invalid pre-signed URL response for ${file.name}`);
            }
            // Step 2: Upload file to S3 using the pre-signed URL
            const uploadResponse = await fetch(url, {
                method: 'PUT',
                body: file,
                headers: { 'Content-Type': file.type }
            });
            if (!uploadResponse.ok) throw new Error(`Upload failed for ${file.name}`);
            // Step 3: Request processing of file
            const processResponse = await fetch(this.props.baseUrl + "/uploaduserpicture", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    file_key: key
                })
            });
            if (!processResponse.ok) throw new Error(`Processing failed for ${file.name}`);
            const data = await processResponse.json();
            // Update user data
            if (data.value.status == true) {
                // Track event
                this.props.logEvent("User activity", "User picture updated");
                this.setState({ upload_image_file: null });
                await this.loadUserData(this.state.user_id);
                this.setPage("");
                window.scrollTo(0, 0);
            }
            // Prepare response
            this.setState({ uploading: false });
            this.props.unsetLoading();
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not upload picture.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_updatePicture");
            this.setState({ uploading: false });
            this.props.unsetLoading();
        }
    }


    /* async updatePicture() {
        this.props.setLoading();
        this.setState({ uploading: true });
        const imageFile = this.state.upload_image_file;
        if (!imageFile) {
            alert('Please select an image file');
            return;
        }
        try {
            this.setState({ uploading: true });

            // Prepare file
            const reader = new FileReader();
            reader.readAsDataURL(imageFile);
            reader.onloadend = async () => {
                const base64String = reader.result.split(",")[1];
                // Send request
                var response = await fetch(this.props.baseUrl + "/uploaduserpicture", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        file: base64String,
                        extension: imageFile.name.split(".").pop(),
                        content_type: imageFile.type
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                if (data.status == true) {
                    // Track event
                    this.props.logEvent("User activity", "User picture updated");
                    this.setState({ upload_image_file: null });
                    await this.loadUserData(this.state.user_id);
                    this.setPage("");
                    window.scrollTo(0, 0);
                }
                this.setState({ uploading: false });
                this.props.unsetLoading();
            }
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not upload picture.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_updatePicture");
            this.setState({ uploading: false });
            this.props.unsetLoading();
        }
    } */


    verifyProfileData() {
        const data = this.state.data;
        var return_value = true;
        // Check if name is set
        if (!data.name || data.name == "" || data.name.length > 50) {
            var name = "Data error";
            var message = "Please provide your name with up to 50 characters.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if username is set
        if (!data.username || data.username == "" || data.username.length > 20) {
            var name = "Data error";
            var message = "Please provide a username with up to 20 characters.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if bio is set
        if (data.bio_description.length > 2000) {
            var name = "Data error";
            var message = "Please provide a bio with up to 2,000 characters.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if birthday is set
        if (data.birthday.length > 50) {
            var name = "Data error";
            var message = "Please provide a valid birthday.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Convert data format for birthday if needed
        if (data.birthday.includes("-")) {
            const birthday = data.birthday;
            const parts = birthday.split('-');
            const formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
            data.birthday = formattedDate;
            this.setState({ birthday: formattedDate });
        }
        // Check if country is set
        if (data.country.length > 50) {
            var name = "Data error";
            var message = "Please provide a valid country.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if country is set
        if (data.hometown.length > 100) {
            var name = "Data error";
            var message = "Please provide a valid hometown.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if country and hometown are properly set
        if (data.country == "" && data.hometown != "") {
            var name = "Data error";
            var message = "Please provide a validcountry.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if socials are set
        if (data.website.length > 100 || data.instagram.length > 100 || data.tiktok.length > 100 || data.youtube.length > 100 || data.linkedin.length > 100 || data.twitterx.length > 100 || data.snapchat.length > 100 || data.facebook.length > 100) {
            var name = "Data error";
            var message = "Please provide social account links with up to 100 characters.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        return return_value;
    }


    verifyEmailData() {
        const email = this.state.email;
        var return_value = true;
        // Check if name is set
        if (!email || email == "" || email.length > 100 || !this.validateEmail(email)) {
            var name = "Data error";
            var message = "Please provide a valid email.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        return return_value;
    }


    verifyPasswordData() {
        var return_value = true;
        // Check if name is set
        if (!this.state.password_old || this.state.password_old == "" || this.state.password_old.length < 5 || this.state.password_old.length > 50) {
            var name = "Data error";
            var message = "Please provide your old password.";
            this.props.setError(name, message);
            return_value = false;
        }
        if (!this.state.password_new || this.state.password_new == "" || this.state.password_new.length < 5 || this.state.password_new.length > 50) {
            var name = "Data error";
            var message = "Please provide a new password with 5 to 50 characters.";
            this.props.setError(name, message);
            return_value = false;
        }
        if (this.state.password_new != this.state.password_new_2) {
            var name = "Data error";
            var message = "Your passwords don't match.";
            this.props.setError(name, message);
            return_value = false;
        }
        return return_value;
    }


    validateEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }


    async submitProfileData() {
        try {
            this.props.setLoading();
            const data_in = this.state.data;
            var status = this.verifyProfileData();
            if (status) {
                // Send request
                var response = await fetch(this.props.baseUrl + "/updateuserdata", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        data: data_in,
                        user_id: this.state.user_id
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                if (data.status == true) {
                    // Track event
                    this.props.logEvent("User activity", "Account updated");
                    this.loadUserData(this.state.user_id);
                    this.setPage("");
                    window.scrollTo(0, 0);
                } else {
                    if (data.error == "username") {
                        // Track error
                        var name = "Error";
                        var message = "This username is already in use. Please choose a different username.";
                        this.props.setError(name, message);
                    } else {
                        // Track error
                        var name = "";
                        var message = "Could not update user data. Please try again later.";
                        this.props.setError(name, message);
                    }
                }
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not update user data. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_submitProfileData");
        } finally {
            this.props.unsetLoading();
        }
    }


    async submitEmailData() {
        try {
            this.props.setLoading();
            if (this.verifyEmailData()) {
                // Send request
                var response = await fetch(this.props.baseUrl + "/updateuseremail", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        email: this.state.email,
                        user_id: this.state.user_id
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                if (data.status == true) {
                    // Track event
                    this.props.logEvent("User activity", "Email updated");
                    this.loadUserData(this.state.user_id);
                    this.setPage("");
                    window.scrollTo(0, 0);
                } else {
                    if (data.error == "email") {
                        // Track error
                        var name = "Error";
                        var message = "This email is already in use. Please choose a different email.";
                        this.props.setError(name, message);
                    } else {
                        // Track error
                        var name = "";
                        var message = "Could not update email. Please try again later.";
                        this.props.setError(name, message);
                    }
                }
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not update email. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_submitEmailData");
        } finally {
            this.props.unsetLoading();
        }
    }


    async submitPasswordData() {
        try {
            this.props.setLoading();
            if (this.verifyPasswordData()) {
                // Send request
                var response = await fetch(this.props.baseUrl + "/updateuserpassword", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        password_old: this.state.password_old,
                        password: this.state.password_new,
                        user_id: this.state.user_id
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                if (data.status == true) {
                    // Track event
                    this.props.logEvent("User activity", "Password updated");
                    this.loadUserData(this.state.user_id);
                    this.setPage("");
                    window.scrollTo(0, 0);
                } else {
                    if (data.error == "password") {
                        // Track error
                        var name = "Error";
                        var message = "You entered the wrong current password. Please try again.";
                        this.props.setError(name, message);
                    } else {
                        // Track error
                        var name = "";
                        var message = "Could not update password. Please try again later.";
                        this.props.setError(name, message);
                    }
                }
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not update password. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_submitPasswordData");
        } finally {
            this.props.unsetLoading();
        }
    }


    render() {

        return (
            <div className="content-container">



                {(!this.state.data.user_id && this.state.missingdata) &&
                    <MissingPage />
                }
                {this.state.data.user_id &&
                    <div className="content-wrapper account-wrapper">
                        <div className="account__sidebar">
                            <div className="account__element account__picture-container">
                                {this.state.data.picture &&
                                    <img src={this.state.data.picture} alt={this.state.data.username} className={"account__element account__picture-inner"} />
                                }
                                {!this.state.data.picture &&
                                    <img src={this.state.sample_picture} alt={this.state.data.username} className={"account__element account__picture-inner"} />
                                }
                                {this.state.login &&
                                    <IconEdit onClick={() => this.setPage("edit_picture")} className="account__picture-icon" />
                                }
                            </div>
                            <div className="account__element">
                                {this.state.data.username &&
                                    <div className="account__contentbox text-subtitle">
                                        {this.state.data.username}
                                    </div>
                                }
                                {this.state.data.username &&
                                    <div className="account__contentbox">
                                        {this.state.data.name}
                                    </div>
                                }
                                {this.state.data.created &&
                                    <div className="account__contentbox text-color-grey">
                                        {"Member since " + format_month_year(this.state.data.created)}
                                    </div>
                                }
                                {(this.state.data.country || this.state.data.hometown) &&
                                    <div className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconLocation className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            {(this.state.data.hometown) + ((this.state.data.hometown && this.state.data.country) ? ", " : "") + (this.state.data.country)}
                                        </div>
                                    </div>
                                }
                            </div>

                            {this.state.login &&
                                <div className="account__element">
                                    <div onClick={() => this.setPage("edit_profile")} className="account__contentbox button button-primary">
                                        Edit profile
                                    </div>
                                    <div onClick={() => this.setPage("change_email")} className="account__contentbox button button-primary-light">
                                        Change email
                                    </div>
                                    <div onClick={() => this.setPage("change_password")} className="account__contentbox button button-primary-light">
                                        Change password
                                    </div>
                                </div>
                            }
                            <div className="account__element">
                                {this.state.data.website != "" &&
                                    <a href={this.state.data.website} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconHome className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Website
                                        </div>
                                    </a>
                                }
                                {this.state.data.instagram != "" &&
                                    <a href={this.state.data.instagram} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconInstagram className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Instagram
                                        </div>
                                    </a>
                                }
                                {this.state.data.tiktok != "" &&
                                    <a href={this.state.data.tiktok} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconTiktok className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            TikTok
                                        </div>
                                    </a>
                                }
                                {this.state.data.snapchat != "" &&
                                    <a href={this.state.data.snapchat} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconLinkedin className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Snapchat
                                        </div>
                                    </a>
                                }
                                {this.state.data.linkedin != "" &&
                                    <a href={this.state.data.linkedin} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconLinkedin className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Linkedin
                                        </div>
                                    </a>
                                }
                                {this.state.data.twitterx != "" &&
                                    <a href={this.state.data.twitterx} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconTwitterx className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            X
                                        </div>
                                    </a>
                                }
                                {this.state.data.facebook != "" &&
                                    <a href={this.state.data.facebook} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconFacebook className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Facebook
                                        </div>
                                    </a>
                                }
                                {this.state.data.youtube != "" &&
                                    <a href={this.state.data.youtube} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconYoutube className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Youtube
                                        </div>
                                    </a>
                                }
                            </div>

                        </div>

                        <div className="account__content-container">

                            {/* Overview */}
                            {this.state.page === "" &&
                                <div className="account__content">

                                    {this.state.login &&
                                        <div className="account__title-container text-title">
                                            <div className="account__title__element">
                                                Overview
                                            </div>
                                        </div>
                                    }

                                    <div className="account__section">
                                        {this.state.userTrips.length >= 1 && this.state.login &&
                                            <div className="account__element text-subtitle">
                                                Your trips
                                            </div>
                                        }
                                        {this.state.userTrips.length >= 1 && !this.state.login &&
                                            <div className="account__element text-subtitle">
                                                Their trips
                                            </div>
                                        }

                                        {this.state.userTrips.length < 1 && this.state.login &&
                                            <div className="account__element text-subtitle">
                                                You don't have any trips yet
                                            </div>
                                        }
                                        {this.state.userTrips.length < 1 && !this.state.login &&
                                            <div className="account__element text-subtitle">
                                                They don't have any trips yet
                                            </div>
                                        }

                                        {this.state.data && this.state.userTrips.length >= 1 &&
                                            <Tripcarousel
                                                data={this.state.userTrips.length >= 1 ? this.state.userTrips.slice(0, 3) : []}
                                            />
                                        }

                                        {this.state.login && this.state.userTrips.length >= 1 &&
                                            <div className="account__element">
                                                <div onClick={() => this.setPage("trips_mine")} className="account__element__link-container">
                                                    <span className="account__element__link__label">
                                                        See all
                                                    </span>
                                                    <IconLink className="account__element__link__icon" />
                                                </div>
                                            </div>
                                        }

                                    </div>

                                    {this.state.login && this.state.userTripUnlocks.length >= 1 &&
                                        <div className="account__section">
                                            <div className="account__element text-subtitle">
                                                Trips you follow
                                            </div>

                                            {this.state.data &&
                                                <Tripcarousel
                                                    data={this.state.userTripUnlocks.length >= 1 ? this.state.userTripUnlocks.slice(0, 3) : []}
                                                />
                                            }

                                            {this.state.userTripUnlocks.length >= 1 &&
                                                <div className="account__element">
                                                    <div onClick={() => this.setPage("trips_following")} className="account__element__link-container">
                                                        <span className="account__element__link__label">
                                                            See all
                                                        </span>
                                                        <IconLink className="account__element__link__icon" />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                    {this.state.login && this.state.userTripViews.length >= 1 &&
                                        <div className="account__section">
                                            <div className="account__element text-subtitle">
                                                {/* Trips you follow */}
                                                Recently viewed trips
                                            </div>

                                            {this.state.data &&
                                                <Tripcarousel
                                                    data={this.state.userTripViews.length >= 1 ? this.state.userTripViews.slice(0, 3) : []}
                                                />
                                            }

                                            {this.state.userTripViews.length >= 1 &&
                                                <div className="account__element">
                                                    <div onClick={() => this.setPage("trips_viewed")} className="account__element__link-container">
                                                        <span className="account__element__link__label">
                                                            See all
                                                        </span>
                                                        <IconLink className="account__element__link__icon" />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                    {/* this.state.login &&
                                    <div className="account__section">
                                        Travelers you follow
                                    </div>
                                 */}

                                </div>
                            }

                            {/* Edit profile page */}
                            {this.state.login && this.state.page === "edit_profile" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Edit profile
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <ForminputText
                                                name={"name"}
                                                label={"Name"}
                                                default_value={this.state.data.name}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>

                                        <div className="account__element">
                                            <ForminputText
                                                name={"username"}
                                                label={"Username"}
                                                default_value={this.state.data.username}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>

                                        <div className="account__element">
                                            <ForminputTextbox
                                                name={"bio_description"}
                                                label={"Your bio"}
                                                placeholder={"Tell use a bit about yourself"}
                                                default_value={this.state.data.bio_description}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={false}
                                            />
                                        </div>

                                        <div className="account__element">
                                            <ForminputDate
                                                name={"birthday"}
                                                label={"Birthday"}
                                                default_value={this.state.data.birthday}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={false}
                                            />
                                        </div>

                                    </div>

                                    {this.props.locations &&
                                        <div className="account__section">
                                            <div className="account__element text-subtitle">
                                                Location
                                            </div>
                                            <div className="account__element">
                                                <ForminputDropdown
                                                    name={"country"}
                                                    label={"Country"}
                                                    placeholder={"Country you live in"}
                                                    list={this.props.locations ? Object.keys(this.props.locations) : []}
                                                    default_value={this.state.data.country}
                                                    setFormValue={this.setDataValue.bind(this)}
                                                    required={false}
                                                />
                                            </div>
                                            {this.state.data.country && this.state.data.country != "" &&
                                                <div className="account__element">
                                                    <ForminputDropdown
                                                        name={"hometown"}
                                                        label={"Hometown"}
                                                        placeholder={"City you live in"}
                                                        list={this.props.locations ? this.props.locations[this.state.data.country] : []}
                                                        default_value={this.state.data.hometown}
                                                        setFormValue={this.setDataValue.bind(this)}
                                                        required={false}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    }

                                    <div className="account__section">
                                        <div className="account__element text-subtitle">
                                            Social accounts
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"website"}
                                                label={"Personal website"}
                                                placeholder={"Link to your website"}
                                                default_value={this.state.data.website}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"instagram"}
                                                label={"Instagram"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.instagram}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"tiktok"}
                                                label={"Tiktok"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.tiktok}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"youtube"}
                                                label={"Youtube"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.youtube}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"linkedin"}
                                                label={"LinkedIn"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.linkedin}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"twitterx"}
                                                label={"X"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.twitterx}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"snapchat"}
                                                label={"Snapchat"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.snapchat}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"facebook"}
                                                label={"Facebook"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.facebook}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <div onClick={this.submitProfileData} className="button button-primary">
                                                Save changes
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            }

                            {/* Update picture page */}
                            {this.state.login && this.state.page === "edit_picture" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Edit picture
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="trip__popup__picture__add-container">
                                            <IconAdd className="trip__popup__picture__add" />
                                            {!this.state.upload_image_file && !this.state.uploading &&
                                                <input type="file" onChange={this.handleFileChangePicture} className="trip__popup__picture__add-input" />
                                            }
                                            {this.state.upload_image_file && !this.state.uploading &&
                                                <div onClick={this.updatePicture} className="trip__popup__picture__add-submit text-bold">
                                                    Upload
                                                </div>
                                            }
                                            {this.state.uploading &&
                                                <div className="trip__popup__picture__add-uploading text-bold">
                                                    Uploading...
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    {/* <div className="account__section">
                                    <div className="account__element">
                                        <div onClick={""} className="button button-primary">
                                            Save changes
                                        </div>
                                    </div>
                                </div> */}

                                </div>
                            }

                            {/* Change email page */}
                            {this.state.login && this.state.page === "change_email" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Change email
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <ForminputText
                                                name={"email"}
                                                label={"E-mail"}
                                                default_value={this.state.data.email}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <div onClick={this.submitEmailData} className="button button-primary">
                                                Save changes
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            }

                            {/* Change password page */}
                            {this.state.login && this.state.page === "change_password" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Change password
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <ForminputPassword
                                                name={"password_old"}
                                                label={"Old password"}
                                                default_value={this.state.password_old}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputPassword
                                                name={"password_new"}
                                                label={"New password"}
                                                default_value={this.state.password_new}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputPassword
                                                name={"password_new_2"}
                                                label={"Confirm new password"}
                                                default_value={this.state.password_new_2}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <div onClick={this.submitPasswordData} className="button button-primary">
                                                Save changes
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            }

                            {/* Trips you follow page */}
                            {this.state.login && this.state.page === "trips_following" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Trips you follow
                                        </div>
                                    </div>

                                    {this.state.data &&
                                        <Tripcarousel
                                            data={this.state.userTripUnlocks}
                                        />
                                    }

                                </div>
                            }

                            {/* Trips you viewed page */}
                            {this.state.login && this.state.page === "trips_viewed" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Recently viewed trips
                                        </div>
                                    </div>

                                    {this.state.data &&
                                        <Tripcarousel
                                            data={this.state.userTripViews}
                                        />
                                    }

                                </div>
                            }

                            {/* Your trips page */}
                            {this.state.login && this.state.page === "trips_mine" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        {this.state.userTrips.length >= 1 &&
                                            <div className="account__title__element">
                                                Your trips
                                            </div>
                                        }
                                        {this.state.userTrips.length < 1 &&
                                            <div className="account__title__element">
                                                You don't have any trips yet
                                            </div>
                                        }
                                    </div>

                                    {this.state.data &&
                                        <Tripcarousel
                                            data={this.state.userTrips}
                                        />
                                    }

                                </div>
                            }

                        </div>

                    </div>
                }
            </div>
        )
    }
}

export default withRouter(Account);